<template>
  <div class="parking-manage app-region blank-l-h blank-r-h">
    <a-row :gutter="64" type="flex">
      <a-col :span="24" :xl="6" class="divide">
        <div class="page-title">车位分区</div>
        <a-row :gutter="16" type="flex" align="middle">
          <a-col flex="1">
            <a-input placeholder="请输入关键词" v-model="tree.keyword" @change="filterKeyword(tree.data, 'tree.searchData', tree.keyword, tree.params.title, tree.params.children)"></a-input>
          </a-col>
          <a-col>
            <a-icon type="plus" class="add-parking" @click="addParkingArea"></a-icon>
          </a-col>
        </a-row>
        <a-spin tip="加载中..." :spinning="tree.loading">
          <a-tree :key="tree.key" :class="{'list': !isPlatformRole}" block-node :tree-data="tree.keyword ? tree.searchData : tree.data" :replaceFields="tree.params" @select="selectTreeNode" :selected-keys="tree.selectedKeys" :load-data="initZoneData">
            <template slot="title" slot-scope="row">
              <a-row type="flex">
                <a-col flex="1">{{row[tree.params.title]}}</a-col>
                <a-col>
                  <a-dropdown>
                    <a-icon type="ellipsis"></a-icon>
                    <a-menu slot="overlay">
                      <a-menu-item @click="renameParkingArea(row)">重命名</a-menu-item>
                      <a-menu-item @click="editParkingArea(row)">管理车位</a-menu-item>
                      <a-menu-item @click="deleteParkingArea(row)">删除</a-menu-item>
                    </a-menu>
                  </a-dropdown>
                </a-col>
              </a-row>
            </template>
          </a-tree>
        </a-spin>
      </a-col>
      <a-col :span="24" :xl="18">
        <div class="page-title">{{name}}（{{total}}）</div>
        <parking-list :id="id" :community-id="communityId" @total="setTotal"></parking-list>
      </a-col>
    </a-row>
    <a-modal :title="modal.title" :confirm-loading="modal.loading" v-model="modal.show" @ok="confirmModal" destroy-on-close centered>
      <a-form-model ref="modalForm" :model="modal.form" layout="vertical" :rules="modal.rules">
        <a-form-model-item label="分区名称" prop="name">
          <a-input v-model="modal.form.name" placeholder="请输入分区名称" allow-clear></a-input>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
  import CommunityService from '@/io/community.js';
  import ParkingService from '@/io/parking.js';
  import ParkingList from '@/views/community/parking/List.vue';

  export default {
    name: 'ParkingManage',
    data() {
      let self = this;
      return {
        tree: {
          key: null,
          selectedKeys: [],
          keyword: null,
          loading: false,
          data: [],
          searchData: [],
          params: {
            children: 'children',
            title: 'name',
            key: '_id'
          }
        },
        id: null,
        communityId: null,
        name: null,
        total: null,
        modal: {
          id: null,
          title: '重命名分区',
          show: false,
          loading: false,
          form: {
            name: null
          },
          rules: {
            name: [
              {
                required: true,
                message: '请输入分区名称'
              }
            ],
          }
        },
      }
    },
    components: {
      ParkingList,
    },
    mounted() {
      this.initTreeSide();
    },
    methods: {
      initTreeSide() {
        this.initTreeData().then(() => {
          this.selectTreeNode([this.tree.data[0][this.tree.params.key]]);
        });
      },
      renameParkingArea(row) {
        this.modal.id = row.id;
        this.modal.form.name = row[this.tree.params.title];
        this.modal.show = true;
      },
      confirmModal() {
        this.$beforeFormSubmit(this.$refs.modalForm, () => {
          this.modal.loading = true;
          ParkingService.updateArea(this.modal.id, this.modal.form.name).then(res => {
            this.$afterFormSubmit('编辑成功', () => {
              this.$depthSearchTree(node => {
                if (node[this.tree.params.key] === this.modal.id) {
                  node[this.tree.params.title] = this.modal.form.name;
                }
              }, this.tree.data);
            });
          }).catch(err => {}).finally(() => {
            this.modal.show = false;
            this.modal.loading = false;
          });
        });
      },
      addParkingArea() {
        this.$router.push({
          name: 'NewParkingArea'
        });
      },
      editParkingArea(data) {
        this.$router.push({
          name: 'EditParkingArea',
          params: {
            id: data.id
          },
          query: {
            community_id: data.communityId
          }
        });
      },
      deleteParkingArea(data) {
        let self = this;
        this.$confirm({
          title: '提示',
          content: '确认删除此车位分区？',
          onOk() {
            ParkingService.delArea(data[self.tree.params.key]).then(res => {
              self.initTreeSide();
            }).catch(err => {});
          }
        });
      },
      setTotal(total) {
        this.total = total;
      },
      selectTreeNode(selectedKeys) {
        if (selectedKeys.length) {
          this.tree.selectedKeys = selectedKeys;
          this.$depthSearchTree(node => {
            if (node[this.tree.params.key] === selectedKeys[0]) {
              if (node.communityId) {
                this.id = node.id;
                this.communityId = node.communityId;
              } else {
                this.id = null;
                this.communityId = node.id;
              }
            }
          }, this.tree.data);
          this.setName();
        }
      },
      setName() {
        this.$depthSearchTree(node => {
          if (node[this.tree.params.key] === this.tree.selectedKeys[0]) {
            this.name = node[this.tree.params.title];
          }
        }, this.tree.data);
      },
      initTreeData() {
        this.tree.loading = true;
        if (!this.$getCookie('communityId')) {
          return CommunityService.listPage().then(res => {
            this.tree.data = res.map(val => {
              val[this.tree.params.key] = `c-${val.id}`;
              val[this.tree.params.children] = [];
              return val;
            });
            this.tree.key = Math.random();
          }).catch(err => {}).finally(() => {
            this.tree.loading = false;
          });
        } else {
          return this.initZoneData();
        }
      },
      initZoneData(data) {
        let communityId = this.$getCookie('communityId') * 1 || data.dataRef.id;
        return ParkingService.areaList(communityId).then(res => {
          res.forEach(val => {
            val[this.tree.params.key] = val.id;
            val.isLeaf = true;
            val.communityId = communityId;
            val.scopedSlots = {
              title: 'title'
            };
          });
          data ? data.dataRef[this.tree.params.children] = res : this.tree.data = res;
        }).catch(err => {}).finally(() => {
          this.tree.loading = false;
        });
      }
    },
  }
</script>

<style lang="less" scoped>
  @import '../../assets/styles/tools.less';
  .parking-manage {
    .add-parking {
      color: @primary-color;
      font-size: @font-size-lg;
      cursor: pointer;
    }
  }
</style>